enum WorkspaceProjectAiReportAssistantQuestionReferenceSourceType {
  vector = 'vector',
  metadata = 'metadata',
}

export default WorkspaceProjectAiReportAssistantQuestionReferenceSourceType
